export const ENTRY_BLOCK_ID = 'entryBlockVDADWQ';
